import React from "react";
import { FiX } from "react-icons/fi";
import { ContainerCloseRound } from "./styles.js";

const CloseRound = ({ onClick, className }) => {
    return (
        <ContainerCloseRound className={className} onClick={onClick} aria-label="Fechar">
            <FiX />
        </ContainerCloseRound>
    )
}

export default CloseRound;
